import { isEmpty } from 'lodash';
import React from 'react';

import styles from './cookieListItem.scss';

interface CookieListItemProps {
  id: string;
  properties: {
    duration: string;
    provider: string;
    purpose: string;
    type: string;
  };
}

const CookieListItem = ({
  id,
  properties
}: CookieListItemProps) => (
  <div className={styles.item}>
    <p className={styles.id} dangerouslySetInnerHTML={{ __html: id }}></p>
    {Object.entries(properties).map((property) => {
      const [key, value] = property;
      return (
        !isEmpty(value) && (
          <div className={styles.row} key={key}>
            <p className={styles.label} dangerouslySetInnerHTML={{ __html: key }}></p>
            <p className={styles.info} dangerouslySetInnerHTML={{ __html: value }}></p>
          </div>
        )
      );
    })}
  </div>
);

export default CookieListItem;
